var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6208 2.13158L10.0001 7.75866L4.37935 2.13158C3.75942 1.51164 2.75322 1.51164 2.1317 2.13158C1.51176 2.75151 1.51176 3.75294 2.1317 4.37287L7.75243 9.99996L2.1317 15.627C1.51176 16.247 1.51176 17.2484 2.1317 17.8683C2.75322 18.4883 3.75942 18.4883 4.37935 17.8683L10.0001 12.2413L15.6208 17.8683C16.2407 18.4883 17.2469 18.4883 17.8685 17.8683C18.4884 17.2484 18.4884 16.247 17.8685 15.627L12.2477 9.99996L17.8685 4.37287C18.4884 3.75294 18.4884 2.75151 17.8685 2.13158C17.2469 1.51164 16.2407 1.51164 15.6208 2.13158Z",
    fill: "#828599"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCross);
export default __webpack_public_path__ + "static/media/ic-cross.3ff4e22c0a6182373228a0e8be3969a9.svg";
export { ForwardRef as ReactComponent };